import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-timing-reason';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Timing reason',
};

const sstTimingReason = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstTimingReason };
